export default function(h, row, index) {
    let d = row.date_create_iso.substring(0,10);
    let t = row.date_create_iso.substring(11,19);
    let _to = ''
    return <span><span class='nobr'>{d}</span><br/><span class='nobr'>{t}</span></span>
}